import AskModal from '../common/AskModal';
import { useSelector } from 'react-redux';

const AskConfirmModal = ({ visible, onConfirm, onCancel }) => {
    const language = useSelector((state) => state.language.language);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;

    return (
        <AskModal
            visible={visible}
            title={isKR ? '새 컨베이어 작성' : isJP ? '新しいコンベアの作成' : isEN ? 'Write New Conveyor' : ''}
            description={isKR ? '새 컨베이어를 작성하시겠습니까?' : isJP ? '新しいコンベアを作成しますか？' : isEN ? 'Write New Conveyor?' : ''}
            confirmText={isKR ? '작성' : isJP ? '作成' : isEN ? 'Write' : ''}
            cancelText={isKR ? '취소' : isJP ? 'キャンセル' : isEN ? 'Cancel' : ''}
            onConfirm={onConfirm}
            onCancel={onCancel}
        />
    );
};

export default AskConfirmModal;
